export default "__VITE_ASSET__Bg0c04v0__"